import {Component, Event, EventEmitter} from '@stencil/core';
import {
  SessionLoaded$,
  WebsdkAllavailabilitiesService,
  WebsdkAvailability
} from '@dedgewebstudio/booking-state-manager';
import {debounceTime, mergeMap} from 'rxjs/operators';
import {of, zip} from 'rxjs';

@Component({
  tag: 'qw-noavailability',
  shadow: false,
})
export class QwNoavailability {
  @Event() qwNoAvailability: EventEmitter<WebsdkAvailability>;

  public componentWillLoad() {
    SessionLoaded$
      .pipe(debounceTime(300))
      .pipe(mergeMap((session) => {
        return zip(WebsdkAllavailabilitiesService.getAllAvailabilities({
          adults: session.context.guests.adults,
          children: session.context.guests.children,
        }), of(session), (availabilityResp, session) => {
          return {availabilityResp, session};
        })
      }))
      .subscribe(({availabilityResp, session}) => {
        if (availabilityResp === null) {
          // websdk is probably not configured
          console.log('---websdk is not configured for allavailabilities check in qw-noavailability---')
          return;
        }
        const res = availabilityResp.find((a) => a.date === session.context.stayPeriod.arrivalDate);
        const timeDiff = new Date(session.context.stayPeriod.departureDate).getTime() - new Date(session.context.stayPeriod.arrivalDate).getTime()
        const dayDiff = Math.round(timeDiff / 86400000);
        // check availability and minstay.
        const availableAny = parseInt(res?.availability) > 0 && dayDiff >= res?.minstay;
        if (!availableAny) {
          this.qwNoAvailability.emit(res);
        }
      });
  }
}
